import { DatePicker, Select, Skeleton } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useQuery } from "react-query";
import { columnChartConfigurationOptions } from "../../config";
import HTTP from "../../services/httpService";
import { disableFutureDates } from "../../services/util";

const { Option } = Select;

function TicketByGroup({ projects }) {
    const [groups, setGroups] = useState([]);
    const [users, setUsers] = useState([]);
    const [columnChartData, setColumnChartData] = useState([]);
    const [defaultYear, setDefaultYear] = useState(moment());
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [userGroupFormData, setUserGroupFormData] = useState({
        staff_id,
        group_id: "",
    });

    const [formData, setFormData] = useState({
        staff_id,
        range_year: defaultYear.get("year"),
        project_id: "-1",
        group_id: "",
        user_id: "",
    });

    const {
        status: jiraGroupStatus,
        data: groupsRes,
        refetch: fetchGroups,
    } = useQuery(
        "groups",
        async () => {
            return await HTTP("/analytics/getJiraGroups", { staff_id });
        },
        { enabled: false },
    );

    const {
        status: jiraUsersStatus,
        data: usersRes,
        refetch: fetchUsers,
    } = useQuery(
        "jira-users",
        async () => {
            return await HTTP("/analytics/getJiraUsersByGroup", {
                ...userGroupFormData,
            });
        },
        { enabled: false },
    );

    const {
        status: columnChartStatus,
        data: columnChartDataRes,
        refetch,
    } = useQuery(
        "TicketByGroup",
        async () => {
            return await HTTP("/analytics/getJiraGroupBarChartData", {
                ...formData,
            });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        fetchGroups();
        fetchUsers();
        refetch();
    }, []);

    useEffect(() => {
        refetch();
    }, [formData]);

    useEffect(() => {
        refetch();
        fetchUsers();
    }, [userGroupFormData]);

    useEffect(() => {
        if (jiraGroupStatus === "success") {
            setGroups(groupsRes.data);
        }
    }, [jiraGroupStatus, groupsRes]);

    useEffect(() => {
        if (jiraUsersStatus === "success") {
            setUsers(usersRes.data);
        }
    }, [jiraUsersStatus, usersRes]);

    useEffect(() => {
        if (columnChartStatus === "success") {
            setColumnChartData(columnChartDataRes.data);
        }
    }, [columnChartStatus, columnChartDataRes]);

    function handleYearChange(date, dateString) {
        const yearSelected = dateString || moment().get("year");
        setDefaultYear(dateString === "" ? moment() : moment(dateString));
        const updatedFormData = {
            ...formData,
            range_year: yearSelected,
        };
        setFormData(updatedFormData);
    }

    function handleProjectSelectionChange(e) {
        let project_id = -1;
        if (e !== undefined) {
            [project_id] = e.split("#");
        }

        const updatedFormData = {
            ...formData,
            project_id,
        };
        setFormData(updatedFormData);
    }

    function handleGroupSelectionChange(e) {
        let group_id = "";
        if (e !== undefined) {
            [group_id] = e.split("#");
        }

        const updatedUserGroupFormData = {
            ...userGroupFormData,
            group_id,
        };
        setUserGroupFormData(updatedUserGroupFormData);

        const updatedFormData = {
            ...formData,
            group_id,
        };
        setFormData(updatedFormData);
    }

    function handleUserSelectionChange(e) {
        let user_id = "";
        if (e !== undefined) {
            [user_id] = e.split("#");
        }

        const updatedUserGroupFormData = {
            ...userGroupFormData,
            user_id,
        };
        setUserGroupFormData(updatedUserGroupFormData);

        const updatedFormData = {
            ...formData,
            user_id,
        };
        setFormData(updatedFormData);
    }

    return (
        <>
            <div className="chart-selection-options">
                <DatePicker
                    className="year-picker"
                    defaultValue={defaultYear}
                    onChange={handleYearChange}
                    picker="year"
                    allowClear={false}
                    disabledDate={disableFutureDates}
                />
                <Select
                    allowClear
                    showSearch
                    placeholder="Project"
                    onChange={handleProjectSelectionChange}
                    className="jira-dashboard-select"
                >
                    {projects.map((e) => (
                        <Option key={`${e.project_id}#${e.project_name}`}>
                            {e.project_name}
                        </Option>
                    ))}
                </Select>
                <Select
                    allowClear
                    showSearch
                    placeholder="Group"
                    onChange={handleGroupSelectionChange}
                    className="jira-dashboard-select"
                >
                    {groups.map((e) => (
                        <Option key={`${e.group_id}#${e.group_name}`}>
                            {e.group_name}
                        </Option>
                    ))}
                </Select>

                {
                    <Select
                        allowClear
                        showSearch
                        placeholder="User"
                        onChange={handleUserSelectionChange}
                        className="jira-dashboard-select"
                    >
                        {users.map((e) => (
                            <Option key={`${e.user_id}#${e.user_name}`}>
                                {e.user_name}
                            </Option>
                        ))}
                    </Select>
                }
            </div>
            {columnChartData.length > 0 ? (
                <Chart
                    className="charts"
                    chartType="ColumnChart"
                    height="50vh"
                    legendToggle
                    options={{
                        ...columnChartConfigurationOptions,
                        title: "Tickets By Group",
                    }}
                    data={columnChartData}
                />
            ) : (
                <Skeleton />
            )}
        </>
    );
}

export default TicketByGroup;
